import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import PRPRateVM from './PRPRateVM';
import { observer } from 'mobx-react';
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import PRPRate from '../../../Models/Catalogue/Pipeline/PRPRate';
import { Misc } from '@singularsystems/neo-core';

@observer
export default class PRPRateView extends Views.ViewBase<PRPRateVM> {

    constructor(props: unknown) {
        super("PRP Rate", PRPRateVM, props);
    }

    public render() {
        return (
            <Neo.Card title="Edit PRP Rates">
                <div>
                    <div className="d-flex justify-content-between mb-4">
                        <Neo.Button icon="arrow-left" variant="light" onClick={() => history.back()}>Back</Neo.Button>
                        <Neo.Button
                            onClick={() => this.viewModel.savePRPRates()}
                            icon="save"
                            pulse={this.viewModel.pageManager.data.isDirty}
                            disabled={!this.viewModel.pageManager.data.isDirty}>
                            Save
                        </Neo.Button>
                    </div>
                    <Neo.Card title="Filter">
                        <div className="row">
                            <Neo.FormGroupInline bind={this.viewModel.criteria.meta.startDate} editorTooltip='If no date is selected, all results will be displayed.' className="col-lg-3" />
                            <Neo.FormGroupInline bind={this.viewModel.criteria.meta.endDate} editorTooltip='If no date is selected, all results will be displayed.' className="col-lg-3" />
                        </div>
                    </Neo.Card>
                    <Neo.Form model={this.viewModel.PRPRateList} showSummaryModal allReadOnly={!this.viewModel.authorisationService.hasRole(CatalogueRoles.PRPRates.Edit)}>
                        <Neo.Card title={"PRP Rates"}>
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControls="bottom" >
                                <NeoGrid.Grid<PRPRate> showAddButton>
                                    {(item, meta) => (
                                        <NeoGrid.Row>
                                            <NeoGrid.Column bind={meta.prpDate} />
                                            <NeoGrid.Column bind={meta.prpRateValue}
                                                numProps={{ format: Misc.NumberFormat.PercentDecimals }}
                                                alignment="center" />
                                            <NeoGrid.ButtonColumn showDelete />
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </Neo.Pager>
                        </Neo.Card>
                    </Neo.Form>
                </div>
            </Neo.Card>
        );
    }
}